import { render, staticRenderFns } from "./BioOmics.vue?vue&type=template&id=217add22&scoped=true&"
import script from "./BioOmics.vue?vue&type=script&lang=js&"
export * from "./BioOmics.vue?vue&type=script&lang=js&"
import style0 from "./BioOmics.vue?vue&type=style&index=0&id=217add22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217add22",
  null
  
)

export default component.exports